import { render } from "./Dropdown4.vue?vue&type=template&id=f0b93d7a"
import script from "./Dropdown4.vue?vue&type=script&lang=js"
export * from "./Dropdown4.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__